export class GroupModel {
    groupId: string | undefined;
    groupName: string | undefined;
    productCode: string | undefined;
    isActive: boolean | undefined;
}